/**
 * Suppress known warnings from third-party libraries
 * These warnings come from amo-styling-library and cannot be fixed
 * without modifying the library code
 */

// Capture console methods immediately at module load time
const originalError = console.error.bind(console);
const originalWarn = console.warn.bind(console);

const suppressedWarningPatterns = [
  // styled-components warnings about unknown props
  /styled-components: it looks like an unknown prop/,
  // forwardRef render function warnings from amo-styling-library
  /forwardRef render functions accept exactly two parameters/,
  /Did you forget to use the ref parameter/,
  // Unsupported style property warnings
  /Unsupported style property/,
  /Did you mean fontFamily/,
  /font-family fontFamily/,
  // React unrecognized DOM props from amo-styling-library
  /React does not recognize the `.*` prop on a DOM element/,
  /wrapperStyle/,
  /anchorEl/,
  /keepMounted/,
  /isSubItem/,
  /isMobile/,
  /isTablet/,
  /pageSize/,
  /checkboxSelection/,
  // List key warnings from amo-styling-library
  /Each child in a list should have a unique "key" prop/,
  /Check the render method of `(WC|UC)`/,
  // Ref warnings from amo-styling-library
  /Function components cannot be given refs/,
  /Did you mean to use React\.forwardRef/,
];

// Initialize console filters immediately when module loads
console.error = (...args: any[]) => {
  const message = args[0]?.toString() || '';

  // Check if this is a suppressed warning
  if (suppressedWarningPatterns.some(pattern => pattern.test(message))) {
    return;
  }

  originalError(...args);
};

console.warn = (...args: any[]) => {
  const message = args[0]?.toString() || '';

  // Check if this is a suppressed warning
  if (suppressedWarningPatterns.some(pattern => pattern.test(message))) {
    return;
  }

  originalWarn(...args);
};

export function initializeConsoleFilters() {
  // Already initialized at module load time
  // This function is kept for backward compatibility
}

// Restore original console methods (for testing)
export function restoreConsole() {
  console.error = originalError;
  console.warn = originalWarn;
}
